@if (!product?.isSoldOut) {
  <div class="flex-m flex-s flex-column-reverse-m flex-column-reverse-s"
    >
    <ng-container *ifTradeStore>
      @if (!product.isComingSoon && !product.isBackSoon) {
        <div class="m-t-5-m m-t-5-s center-s"
          >
          <div class="p1">{{ 'Quantity' | translate }}:</div>
          <item-qty class="block col-1 m-t-2"
            [(model)]="qty"
            [product]="product"
            [min]="product.minQty"
            [bigVariant]="true"
            [isDisabled]="!product.isSalable()"
            [canUseIncrementAsMinQty]="true"
          (qtyChange)="onQtyChange()"></item-qty>
        </div>
      }
    </ng-container>
    @if (product.isComingSoon || product.isBackSoon) {
      <xnotif-form [model]="product"
      ></xnotif-form>
    }
  </div>
}

<!-- On mobile display buttons in a bottom panel -->
<bottom-panel *ifSize="'SM'"
  [bottomPanelRestricted]="['footer']">
  <ng-container *ngTemplateOutlet="buttonsTpl"></ng-container>
</bottom-panel>

<!-- On desktop display buttons in this place -->
<div *ifSize="'!SM'"
  class="m-t-7 m-t-5-s m-t-5-m">
  <ng-container *ngTemplateOutlet="buttonsTpl"></ng-container>
</div>

@if (warning) {
  <label-pane class="m-t-7 m-t-5-s m-t-5-m"
    ><span class="col-6 p1">{{ warning }}</span></label-pane>
  }

  <ng-template #buttonsTpl>
    @if (!product?.isComingSoon && !product?.isBackSoon && !product?.isSoldOut) {
      <div class="flex">
        <action class="button p-r-0-s p-l-0-s p-r-0-m p-l-0-m flex-grow"
          [class.is-disabled]="isDisabled"
          [status]="status"
          (error)="onAddToBasketError($event)"
          [iCmsModalOpen]="bundleModalId"
          [iCmsModalOpenData]="{ product, selection: bundleSelection, buyRequest: buyRequest, qty: qty }"
          cy-basketAddButton>
          {{ 'Create your bundle' | translate }}
        </action>
        <product-view-wishlist-toggle class="m-l-2"
          [productId]="product.id"
        *ifNotTradeStore></product-view-wishlist-toggle>
      </div>
      <result class="block"
      [status]="status"></result>
    }
  </ng-template>